import { render } from "./TableSummaryCost.vue?vue&type=template&id=1b34d848"
import script from "./TableSummaryCost.vue?vue&type=script&lang=js"
export * from "./TableSummaryCost.vue?vue&type=script&lang=js"
script.render = render

export default script